//  ----------      START   IMPORT  BLOCK       ----------
//  Widgets
import {Card, Container, Row, Col, Button, ButtonGroup, Dropdown} from 'react-bootstrap';
import MedicSearchBar from '../MedicSearchForm/MedicSearchBar';
//  Context
import { useLanguage } from '../../API/Context/LanguageContext';
//  Config
import VocabFloatingFilterBar from '../../ConfigFiles/multilingual/VocabFloatingFilterBar';
//  ----------      END   IMPORT  BLOCK       ----------


const FloatingFilterBar = ({ onFilterChange, onSearch, initialQuery = '' }) => {
  //  Consume context
  const { lan } = useLanguage();

  return (
    // Preserving w-100 for width and p-3 for padding
    <Card className="mb-3 p-3 shadow-sm sticky-top w-100" style={{ top: 0, zIndex: 10 }}>
      <Container fluid>
        {/* Added mb-3 here to create vertical spacing between this row (search/days) and the city dropdown row below */}
        <Row className="gy-2 mb-3"> 
          <Col>
            {/* MedicSearchBar (Widget 1) */}
            <MedicSearchBar onSearch={onSearch} initialValue={initialQuery}/>
            {/* Added mt-3 here to create vertical spacing below MedicSearchBar (Widget 1) */}
            <div className="d-flex flex-wrap align-items-center mt-3">
              <span className="me-2 fw-semibold">{VocabFloatingFilterBar.availability[lan]}:</span>
              {/* ButtonGroup (Widget 2) */}
              <ButtonGroup>
                {[1, 3, 5, 7].map((day) => (
                  <Button
                    key={day}
                    variant="outline-primary"
                    onClick={() => onFilterChange('days', day)}
                  >
                    {day} {lan === 0 ? 'días' : 'Days'}
                  </Button>
                ))}
              </ButtonGroup>
            </div>
          </Col>
</Row>
        <Row className="align-items-center gy-2">
        
          <Col md="auto" xs={12}>
            {/* Dropdown (Widget 3) */}
            <Dropdown onSelect={(e) => onFilterChange('city', e)}>
              <Dropdown.Toggle variant="outline-secondary">
                {lan === 0 ? 'Seleccionar ciudad' : 'Select City'}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey="New York">New York</Dropdown.Item>
                <Dropdown.Item eventKey="London">London</Dropdown.Item>
                <Dropdown.Item eventKey="Tokyo">Tokyo</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default FloatingFilterBar;